import * as vp from 'vopay';
import { useTranslation } from 'react-i18next';
import styles from './AccountingSystemOpen.module.scss';

const { BodyText, withStyles } = vp;
const cn = withStyles(styles);

export default function RemainingAmount({
  totalAmount,
  currency,
  paymentAmount,
  creditAmount = 0,
}: {
  totalAmount: number;
  currency: string;
  paymentAmount?: string;
  creditAmount?: number;
}) {
  const { t } = useTranslation('translations', { keyPrefix: 'AccountingSystem.OpenTab.Elinx' });
  const remaining = totalAmount - Number(vp.sanitizeToNumeric(String(paymentAmount || ''))) - creditAmount;
  const displayValue = Math.round(remaining) < 0 ? totalAmount : Math.abs(remaining);

  return (
    <BodyText size="sm" className={cn('remainingHelper')}>
      <span className={cn('remainingHelperLabel')}>
        {t('remainingHelper', { defaultValue: 'Remaining after this payment:' })}
      </span>{' '}
      {currency} {vp.formattedCurrency(String(displayValue))}
    </BodyText>
  );
}
